import { render, staticRenderFns } from "./addVideo.vue?vue&type=template&id=04f2388e&ref=addVideo&"
import script from "./addVideo.vue?vue&type=script&lang=js&"
export * from "./addVideo.vue?vue&type=script&lang=js&"
import style0 from "./addVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports